<template>
  <div class="training-level-detail-component">
    <div class="training-level-header">
      <div v-if="levelData.level.seq"
           class="training-date"
      >
        第{{ levelData.level.seq }}天
        <span class="training-tips"
              @click="handleShowTips"
        >阅读提示</span>
      </div>
      <ym-button class="training-toggle-btn"
                 type="primary"
                 size="small"
                 round
                 :plain="isEnglishType"
                 @click="handleChangeLanguage"
      >
        {{ toggleBtnText }}
      </ym-button>
    </div>
    <div class="training-title">{{ levelData.level.title }}</div>
    <div class="training-audio"
         v-for="(item, index) in levelData.level.audios"
         :key="index"
    >
      <audio-player v-if="item"
                    :current="item.id"
                    :source="item.source"
                    :duration="item.duration"
                    :title="item.title"
                    type="level"
      />
    </div>
    <ym-content class="training-about"
                :content="levelData.level.about"
    />
    <div v-if="showReadCount"
         class="training-reading-count"
    >
      ({{ levelData.level.readCount }} words)
    </div>
    <div class="training-tips-modal">
      <center-popup :show.sync="visible"
                    title="阅读提示"
      >
        <div class="training-popup-content"
             v-html="levelData.level.tips"
        ></div>
      </center-popup>
    </div>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import AudioPlayer from '@/pages/TrainingLevel/components/Player';
  import validator from '@/utils/validator';
  import Content from '@/components/RichText';
  import CenterPopup from '@/components/CenterPopup';

  export default {
    name: 'TrainingLevelDetailContent',
    components: {
      'ym-button': Button,
      AudioPlayer,
      'ym-content': Content,
      CenterPopup,
    },
    props: {
      levelData: {
        required: true,
        validator(val) {
          return validator.isObject(val);
        },
      },
    },
    data() {
      return {
        visible: false,
        audioIcon: 'play-fill',
        isPlaying: false,
      };
    },
    computed: {
      level() {
        return this.levelData.level;
      },
      type() {
        return this.level.type;
      },
      isEnglishType() {
        return this.type === 'english';
      },
      toggleBtnText() {
        return this.isEnglishType ? '中文版对照' : '返回英文版';
      },
      showReadCount() {
        const { level, isEnglishType } = this;
        const { readCount } = level;
        return isEnglishType && readCount;
      },
    },
    methods: {
      handleChangeLanguage() {
        const { isEnglishType } = this;
        this.$emit('changeData', isEnglishType ? 'chinese' : 'english');
      },
      handleShowTips() {
        this.visible = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-level-detail-component {
    padding: @size-base * 2 @size-base;
  }

  .training-level-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .training-date {
    font-size: @font-size-large;
    color: @color-text-lighter;
  }

  .training-tips {
    display: inline-block;
    width: 140px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 20px;
    font-size: @font-size-small;
    color: @color-text-light;
    background: @background-color-base;
    margin-left: @size-extra-small;
  }

  .training-toggle-btn {
    width: 222px;
    color: @color-white;
    background: @training-primary-color;
    border: @border-width-base @border-style-base @training-primary-color;

    &.is-plain {
      color: @training-primary-color;
      background: none;
    }
  }

  .training-title {
    font-size: @font-size-extra-extra-large;
    font-weight: @font-weight-primary;
    margin-top: @size-base;
    margin-bottom: @size-medium;
  }

  .training-audio {
    background: @training-primary-color-lighter;
    border-radius: 16px;
    padding: @size-medium;
    margin-bottom: @size-base;
  }

  .training-icon {
    width: 80px;
    height: 80px;
    border-radius: 40px;
    background: @color-white;
    color: @training-primary-color;
    box-shadow: @training-box-shadow-lighter;
    font-size: @font-size-large;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .training-audio-info {
    display: flex;
    flex-direction: column;
    margin-left: @size-base;
  }

  .training-audio-title {
    margin-bottom: @size-extra-small;
    font-size: @font-size-medium;
    color: @color-text-base;
  }

  .training-audio-duration {
    font-size: @font-size-base;
    color: @color-text-light;
  }

  .training-about {
    line-height: 1.8;
    font-size: @font-size-medium;
    word-wrap: break-word;
  }

  .training-popup-content {
    box-sizing: border-box;
    width: 570px;
    padding: @size-base;
    max-height: 600px;
    text-align: left;
    font-size: @font-size-base;
    line-height: 1.6;
    word-break: break-word;
    overflow: scroll;
    border-radius: 16px;
  }
</style>
